// src/pages/AdminHome.tsx — admin landing: infra panel, override form, links.
import { Link } from "wouter";
import { Card, PageHeader } from "@/components/ui";
import { INFRA_FACTS, QUICK_LINKS } from "@/lib/infra";
import { OverrideForm } from "@/components/OverrideForm";

export function AdminHome() {
  return (
    <div className="space-y-8">
      <PageHeader title="Admin Home" subtitle="Platform operations for PULSE." />

      <section className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Link href="/admin/participants">
          <Card className="cursor-pointer transition hover:border-ls-accent/50">
            <p className="font-medium text-ls-fg">Participants</p>
            <p className="text-xs text-ls-muted">Search and filter the canonical user roster.</p>
          </Card>
        </Link>
        <Link href="/admin/audit-log">
          <Card className="cursor-pointer transition hover:border-ls-accent/50">
            <p className="font-medium text-ls-fg">Audit Log</p>
            <p className="text-xs text-ls-muted">Paginated, filterable record of sensitive actions.</p>
          </Card>
        </Link>
      </section>

      <section>
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-ls-muted">
          Infra status
        </h2>
        <Card>
          <dl className="grid grid-cols-1 gap-y-2 sm:grid-cols-2">
            {INFRA_FACTS.map((f) => (
              <div key={f.label} className="flex justify-between gap-4 sm:flex-col sm:justify-start">
                <dt className="text-xs text-ls-muted">{f.label}</dt>
                <dd className="font-mono text-sm text-ls-fg">{f.value}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-3 text-xs text-ls-muted">
            Static panel. Live Cloud Run health is a future enhancement.
          </p>
        </Card>
      </section>

      <section>
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-ls-muted">
          Admin override
        </h2>
        <OverrideForm />
      </section>

      <section>
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-ls-muted">
          Quick links
        </h2>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {QUICK_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-lg border border-white/10 px-3 py-2 text-sm text-ls-fg hover:border-ls-accent/50"
            >
              {l.label} ↗
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
